import React, { useState } from "react";
import { Topbar, Alert } from "@components";
import { useNavigate } from "react-router-dom";
import {
	CopyLink,
	CopyTitle,
	InviteLinkContainer,
	InviteLinkTerm,
	InviteLinkTerms,
	InviteLinkTitle,
	CreateLinkButton,
	TermsAndConditionsContainer,
	CreateLinkWrapper,
	Modal,
	ButtonWrapper,
	ButtonDiv,
	TitleLinkWrapper,
	TopImg,
	Desc,
} from "./InviteLink.style";
import { YellowLine, ChainFilled } from "@assets";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { api } from "@api";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { openAlert } from "@redux/app/appSlice";
import { ENGLISH_LANGUAGE_CODE_LK, BURMESE_LANGUAGE_CODE_LK } from "@constants";
import { localStorage } from "@utils";

const InviteLink = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);
	const [isOpen, setIsOpen] = useState(false);
	const [textToCopy, setTextToCopy] = useState("");

	const userPreferedLanguage = localStorage.getUserPreferedLanguage();
	const { invite_link_rule } = useSelector((state) => state.app.settings);

	const inviteLinkRule =
		userPreferedLanguage === ENGLISH_LANGUAGE_CODE_LK
			? invite_link_rule?.text_en
			: userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK
				? invite_link_rule?.text_mm
				: invite_link_rule?.text_ch;

	const getInviteLink = () => {
		setLoading(true);
		api
			.postReferral()
			.then(({ referral_id }) => {
				const domain = window.location.hostname;
				setLoading(false);
				setTextToCopy(`${domain}/register?referral_id=${referral_id}`);
				setIsOpen(true);
			})
			.catch((errorMsg) => {
				setLoading(false);
				showAlert({
					message: errorMsg,
					isError: true,
				});
			});
	};

	const handleCopyClick = () => {
		navigator.clipboard
			.writeText(textToCopy)
			.then(() => {
				setIsOpen(false);
				showAlert({
					message: t("common.copied"),
					successCallback: goBack,
				});
			})
			.catch((error) => {
				//create input or text area
				const input = document.createElement("input");
				input.setAttribute("value", textToCopy);
				document.body.appendChild(input);
				input.select();
				const result = document.execCommand("copy");
				document.body.removeChild(input);
				if (result) {
					showAlert({
						message: t("common.copied"),
						successCallback: goBack,
					});
				} else {
					showAlert({
						message: "Failed to copy to clipboard.",
						isError: true,
					});
				}
			});
	};

	const goBack = () => {
		navigate(`/${PUBLIC_ROUTE.HOME}/${PUBLIC_ROUTE.PROFILE}`);
	};

	const showAlert = (data) => {
		dispatch(openAlert(data));
	};

	return (
		<>
			<Topbar title={t("profile.inviteLink")} goBack={goBack} shadow={false} />
			<InviteLinkContainer>

				<TopImg />

				<CreateLinkWrapper>
					<InviteLinkTitle>{t("profile.inviteLinkSubtitle")}</InviteLinkTitle>
				</CreateLinkWrapper>

				<Desc> {t("profile.inviteLinkDesc", {
					appName: t("common.appName")
				})} </Desc>

				<YellowLine style={{width: "calc(100% - 60px)", margin: "24px 0"}} />

				<TermsAndConditionsContainer>
					<InviteLinkTerm>{t("profile.inviteLinkTerms")}</InviteLinkTerm>
					<InviteLinkTerms
						dangerouslySetInnerHTML={{ __html: inviteLinkRule }}
					/>
				</TermsAndConditionsContainer>

				<CreateLinkButton
					language={userPreferedLanguage}
					onClick={getInviteLink}
					loading={loading}
				>
					{t("common.create")}
				</CreateLinkButton>

			</InviteLinkContainer>
			<Modal
				open={isOpen}
				closable={false}
				style={{
					textAlign: "center",
				}}
				centered={true}
				footer={null}
				width={326}
			>
				<ChainFilled id='modal-icon' />
				<TitleLinkWrapper>
					<CopyTitle>{t("profile.inviteLinkModalContent")}</CopyTitle>
					<CopyLink>{textToCopy}</CopyLink>
				</TitleLinkWrapper>
				<ButtonWrapper>
					<ButtonDiv
						type="default"
						onClick={() => setIsOpen(false)}
					>
						{t("common.cancel")}
					</ButtonDiv>
					<ButtonDiv 
						type="outline"
						onClick={handleCopyClick}
					>{t("common.copy")}</ButtonDiv>
				</ButtonWrapper>
			</Modal>
			<Alert />
		</>
	);
};

export default InviteLink;
